import _ from 'lodash'
import io, { Socket } from 'socket.io-client'

export namespace cruzSocket {
  export var socket: Socket

  export function init(name: string) {
    socket = io(process.env.NEXT_PUBLIC_SOCKET_URL + '/cruz', {})
    socket.on('connect', () => {
      socket.emit('pathChanged', name)
    })
  }

  export async function reconnect() {
    if (socket) {
      socket.disconnect()
    }
    socket.connect()
  }

  export async function disconnect() {
    socket.disconnect()
  }

}